export default __webpack_public_path__ + "static/media/eating_tabby.0543abfd.png";